import { FileInput, GridCol, Text, Textarea, TextInput } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import Cookies from "js-cookie";
import { FaFileAlt } from "react-icons/fa";
import { FormFileFieldLabels, FormFileValues } from "types/module/Firmware";

const FormInitial = ({
  fieldLabels,
  form,
  formsReadOnly,
  isSubmitting,
  setIsNotDnt,
  fileError,
}: {
    fieldLabels: FormFileFieldLabels;
    form: UseFormReturnType<FormFileValues>;
    formsReadOnly: boolean;
    isSubmitting: boolean;
    setIsNotDnt: React.Dispatch<React.SetStateAction<boolean>>;
    fileError: string;
}) => {
  return (
    <>
      <GridCol span={12}>
        <TextInput
          label={fieldLabels.manufacturer}
          value={Cookies.get("manufacturer")}
          readOnly
        />
      </GridCol>
      <GridCol span={{ base: 12, md: 6 }}>
        <TextInput
          key={form.key("releaseNotesUrl")}
          label={fieldLabels.releaseNotesUrl}
          rightSection="optional"
          placeholder={`Enter ${fieldLabels.releaseNotesUrl}`}
          disabled={formsReadOnly || isSubmitting}
          {...form.getInputProps("releaseNotesUrl")}
        />
      </GridCol>
      <GridCol span={{ base: 12, md: 6 }}>
        <Textarea
          key={form.key("comments")}
          label={fieldLabels.comments}
          rightSection="optional"
          placeholder={`Enter ${fieldLabels.comments}`}
          disabled={formsReadOnly || isSubmitting}
          rows={1}
          {...form.getInputProps("comments")}
        />
      </GridCol>

      {!formsReadOnly && (
        <GridCol span={12}>
          <FileInput
            key={form.key("firmwareFile")}
            label={fieldLabels.firmwareFile}
            leftSection={<FaFileAlt />}
            placeholder={`Attach ${fieldLabels.firmwareFile}`}
            leftSectionPointerEvents="none"
            disabled={isSubmitting}
            {...form.getInputProps("firmwareFile")}
            onChange={(event) => {
              setIsNotDnt(event?.name?.split(".").pop() !== "dnt");
              form.setFieldValue("firmwareFile", event);
            }}
          />
          <Text fz="xs" c="red">
            {fileError}
          </Text>

          <Text fz="xs">
            Note: Please do not upload test firmware, upload production firmware
            only. Uploaded files will be visible to all users of the Dante
            Updater application.
          </Text>
        </GridCol>
      )}
    </>
  );
};

export default FormInitial;
